import { useState, useEffect, useRef } from 'react';

interface SpamProtectionResult {
  honeypotValue: string;
  setHoneypotValue: (value: string) => void;
  isSpam: () => boolean;
  formStartTime: number;
  HoneypotField: React.FC;
}

// Minimum time in milliseconds that a human would need to fill out a form
const MIN_FORM_TIME_MS = 3000; // 3 seconds

export function useSpamProtection(): SpamProtectionResult {
  const [honeypotValue, setHoneypotValue] = useState('');
  const formStartTime = useRef(Date.now());

  useEffect(() => {
    // Reset start time when hook is mounted (form opened)
    formStartTime.current = Date.now();
  }, []);

  const isSpam = (): boolean => {
    const timeSpent = Date.now() - formStartTime.current;
    
    // If honeypot field is filled, it's a bot
    if (honeypotValue.trim() !== '') {
      console.log('Spam detected: honeypot field filled');
      return true;
    }
    
    // If form was submitted too quickly, it's likely a bot
    if (timeSpent < MIN_FORM_TIME_MS) {
      console.log('Spam detected: form submitted too quickly', timeSpent, 'ms');
      return true;
    }
    
    return false;
  };

  // Invisible honeypot field component
  const HoneypotField: React.FC = () => (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        height: 0,
        width: 0,
        overflow: 'hidden',
      }}
    >
      <label htmlFor="website_url">Lämna detta fält tomt</label>
      <input
        type="text"
        id="website_url"
        name="website_url"
        tabIndex={-1}
        autoComplete="off"
        value={honeypotValue}
        onChange={(e) => setHoneypotValue(e.target.value)}
      />
    </div>
  );

  return {
    honeypotValue,
    setHoneypotValue,
    isSpam,
    formStartTime: formStartTime.current,
    HoneypotField,
  };
}
